import { OPERATION } from './handlers'
import {
  distrikt, isOptionalDistrikt, isValidDistrikt, setDistrikt
} from './hardcoded'
import { debug, locallyAr5, setAvailableLineAttributes } from './storage'

function addHiddenFormInput(form, column_id, column_value, classname) {
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const input = document.createElement('input');
  input.id = column_id;
  input.className = classname;
  input.value = column_value;
  input.type = 'hidden';
  div.appendChild(input);
  form.prepend(div);
}

export function addFormInput(
  form, list, attributeValues, id, header, help_url, dataType, classname
) {
  if (list) {
    addListInput(form, id, attributeValues, header, help_url, classname);
  } else {
    if (dataType === 'date') addDateInput(form, id, header, help_url);
    if (dataType === 'text') addTextInput(form, id, header, classname);
  }
}

function addDateInput(form, id, header, help_url) {
  const label = header.replace('registrering', 'verifisering');
  const fie = document.createElement('div');
  fie.className = 'form-input-element';
  const lbl = document.createElement('label');
  const c = (locallyAr5 ? 'black' : 'white');
  lbl.className = 'label-text ' + c + '-text';
  lbl.innerHTML = label + ':';
  const wb = document.createElement('div');
  wb.className = 'round-corners';
  const i = document.createElement('input');
  // i.id = id;
  i.name = id;
  i.type = 'date';
  i.className = 'datepicker';
  const today = new Date();
  const isoToday = today.toISOString().substring(0, 10); // yyyy-mm-dd
  // i.valueAsDate = new Date(); // today // did not work for webkit
  if (!locallyAr5) i.value = isoToday;
  else i.required = true;
  // i.min = '2000-01-01'; // if they want red style before starting changes
  i.max = isoToday; // today
  // i.pattern = '[0-3][1-9].[0-1][1-9].20[0-3][0-9]';
  // i.onchange = () => { console.log('onchange'); }; // did not work
  // i.oninvalid = () => { console.log('oninvalid'); }; // did not work
  i.oninput = () => {
    if (!i.checkValidity()) {
      if (i.validity.rangeUnderflow) {
        const min = i.min.split('-').reverse().join('.');
        i.setCustomValidity('Datoen må være ' + min + ' eller senere');
      } else if (i.validity.rangeOverflow) {
        const max = i.max.split('-').reverse().join('.');
        i.setCustomValidity('Datoen må være ' + max + ' eller tidligere');
      } else if (i.validity.badInput) {
        i.setCustomValidity('Datoen er ugyldig eller ufullstendig');
      } else i.setCustomValidity('');
    }
    i.title = i.validationMessage; // fix Chrome 86 bug
  };
  wb.appendChild(i);
  fie.appendChild(lbl);
  fie.appendChild(wb);
  form.appendChild(fie);
}

function addListInput(form, id, attributeValues, header, help_url, classname) {
  if (debug < 6) console.log('creating select:', id, attributeValues);
  const c = (locallyAr5 ? 'black' : 'white');
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const label = document.createElement('label');
  label.className = `label-text ${c}-text`;
  label.innerHTML = `${header}:`;
  if (header !== '') div.appendChild(label);
  const select = document.createElement('select');
  select.id = id;
  select.className = `form-control ${classname} ${id}`;
  select.required = locallyAr5;
  div.appendChild(select);

  if ((id.length === 18) && (id.indexOf('reinbeitebruker_id') > -1))
    setDistrikt(attributeValues);
  let init = false;
  if (attributeValues.length === 1)
    init = true; // select the only choise
  else {
    const o = document.createElement('option');
    o.value = '';
    o.selected = true;
    if ((id.indexOf('bruker_id2') > -1) || (id.indexOf('bruker_id3') > -1))
      o.innerHTML = 'Ikke spesifisert';
    else {
      o.disabled = true;
      o.hidden = true;
      o.innerHTML = 'Velg...';
    }
    select.appendChild(o);
  }

  const arealbruk = ['arealtype', 'treslag', 'skogbonitet', 'grunnforhold'];
  const appendNumber = arealbruk.indexOf(id) > -1;
  attributeValues.forEach(attribute => {
    const value = attribute.value;
    const displayed = attribute['display_value'];
    const disabled = false && (value === 'dig');
    const toHide = (
      (isOptionalDistrikt(id) && !isValidDistrikt(value)) ||
      (id === 'datafangstmetode' && ['dig', 'sat'].indexOf(value) < 0) ||
      (id === 'klassifiseringsmetode' && ['uAnnen', 'uFjern'].indexOf(value) > -1)
    );
    if (displayed !== '') {
      const o = document.createElement('option');
      o.value = value;
      if (init) { o.selected = true; init = false; }
      o.disabled = disabled;
      o.hidden = toHide;
      o.innerHTML = displayed + (appendNumber ? ` (${value})` : '');
      select.appendChild(o);
    } else {
      if (attributeValues.length === 2) init = true;
    }
  });

  if ((distrikt.length === 1) && isOptionalDistrikt(id)) {
    if (debug < 5) console.log('distrikt:', distrikt, '(is optional)');
    return;
  }
  form.append(div);

  // hide third field
  if (id.indexOf('reinbeitebruker_id3') > -1) {
    const sibling3 = form.getElementsByClassName('reinbeitebruker_id3')[0];
    sibling3.parentNode.style.display = 'none';
    const sibling2 = form.getElementsByClassName('reinbeitebruker_id2')[0];
    sibling2.addEventListener('change', () => {
      sibling3.parentNode.style.display = sibling2.value ? 'block' : 'none';
    });
  }
}

function addTextInput(form, id, header, classname) {
  if (debug < 10) { console.log('creating text input:', id, form); }
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const label = document.createElement('label');
  label.htmlFor = id;
  const c = (locallyAr5 ? 'black' : 'white');
  label.className = 'label-text ' + c + '-text';
  label.innerHTML = header + ':';
  if (header) { div.appendChild(label); }
  const input = document.createElement('input');
  input.id = id;
  input.type = 'text';
  input.className = classname
  if (locallyAr5 && header.indexOf('informasjon') > -1) {
    const hint = 'Valgfritt – kun for viktige opplysninger';
    input.placeholder = hint;
    input.title = hint;
  }
  // input.onblur = () => {
  //   if (input.value) { console.log('Blurred, save', input.value); }
  // };
  div.appendChild(input);
  form.appendChild(div);
}

export function valueIsNotSelectable(v, s) {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    if (s.options[i].value === v.toString()) return false;
  }
  return true;
}

export function valueIsHidden(v, s) {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    const o = s.options[i];
    if (o.value === v.toString() && (o.hidden)) return true;
  }
  return false;
}

export const getIndexFromValue = (v, s) => {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    const o = s.options[i];
    if (o.value === v?.toString()) return i;
  }
  return -1;
};

export const populatePreliminaryForm = (form, entities) => {
  // Delete all form elements
  form.innerHTML = '';

  // If there is no attributes then save the line automatically
  // when the user finishes the line
  // Default we set it to false and if there is one
  // columns that will be shown to the user, then we
  // set it to true
  setAvailableLineAttributes(false);
  entities.forEach(attribute => {
    const display = attribute['display_column'];
    const valuesEntities = attribute['prepareEditLayerResAttrValuesEntities'];
    if (display === 'yes'
      || (OPERATION === 'edit' && display === 'display_on_update')
      || (OPERATION !== 'edit' && display === 'display_on_add')
    ) {
      setAvailableLineAttributes(true);

      let list = false;
      const attributeChoices = new Array();

      const id = attribute['column_id'];
      const header = attribute['column_header_display'];
      // const name = attribute['column_name'];
      const help_url = attribute['column_help_url'];
      const dataType = attribute['column_datatype'];

      // Check if this attribute is a confined list
      if (valuesEntities.length > 0) {
        list = true;
        valuesEntities.forEach(attributeValue => {
          let a = {};
          a['display_value'] = attributeValue['column_display'];
          a['value'] = attributeValue['column_value'];
          attributeChoices.push(a);
        });
      }
      addFormInput(
        form, list, attributeChoices,
        id, header, help_url, dataType, 'form-line-attribute'
      );
    } else {
      let value = null;
      const id = attribute['column_id'];
      if (valuesEntities > 0) {
        const entity = valuesEntities[0];
        if (entity.hasOwnProperty('column_value')) {
          value = entity['column_value'];
        }
      }
      addHiddenFormInput(form, id, value, 'form-line-attribute');
    }
  });
};

export const setToday = (siblingSelectorWhichWasChangedByUser, changed, sfs) => {
  const p = siblingSelectorWhichWasChangedByUser.parentNode.parentNode;
  // name="verifiseringsdato" type="date" class="datepicker"
  const ds = p.getElementsByClassName('datepicker');
  const d = (ds.length > 0) ? ds[0] : null;
  if (d && d.name.indexOf('verifiseringsdato') > -1) {
    const today = new Date();
    const isoToday = today.toISOString().substring(0, 10); // yyyy-mm-dd
    if (d.value === isoToday) return;
    // d.valueAsDate = today; // did not work for webkit
    d.value = isoToday;
    changed[d.name] = d.value;
    sfs.forEach(sf => sf.set(d.name, d.value));
  }
};
